import { useEffect } from 'react';
import PortalIdParser from 'PortalIdParser';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { Text } from 'foundations-components/components/Text';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { Link } from 'foundations-components/transitional/components/Link';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Metrics } from 'reporting-ui-components/monitoring/Metrics';
import { EXTERNAL } from 'reporting-data/constants/dataTypes';
import { INLINE_COMPARISON_LABEL_RENDERED } from '../../constants/trackingMetrics';
// @ts-expect-error Untyped import
import { ConditionalLabel, Label } from './Label';
import { jsx as _jsx } from "react/jsx-runtime";
const SUNSET_URL = `/product-updates/${PortalIdParser.get()}/all?rollout=149892`;

// Note: This is a solution specific to the Legacy Funnel Sunset -
// in SRV, there are alert banners containing info about the upcoming, but
// given limited real estate on a dashboard, the sunset info is surfaced in the tooltip
// as opposed to adding an alert banner
const getIsDashboardView = () => {
  const isSRVModalOpen = !!window.location.pathname.split('/')[5];
  const isSRVModalOnDashboard = window.location.href.includes('reports-dashboard') && !isSRVModalOpen;
  return isSRVModalOnDashboard;
};
export const condition = ({
  config
}) => config && config.get('configType') === 'FUNNEL' && config.get('dataType') !== EXTERNAL;
export const render = Label(() => {
  const isDashboardView = getIsDashboardView();
  useEffect(() => {
    Metrics.counter(INLINE_COMPARISON_LABEL_RENDERED).increment();
  }, []);
  return /*#__PURE__*/_jsx(Tooltip, {
    placement: "right",
    headingText: /*#__PURE__*/_jsx(Text, {
      typography: "heading-50",
      use: "on-dark",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingLabels.upcomingMigration.tooltip.header"
      })
    }),
    title: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "settingLabels.upcomingMigration.tooltip.body_jsx",
      options: {
        href: SUNSET_URL
      },
      elements: {
        Link: props => /*#__PURE__*/_jsx(Link, Object.assign({
          external: true
        }, props))
      }
    }),
    disabled: !isDashboardView,
    children: /*#__PURE__*/_jsx(Badge, {
      use: "calypso",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "settingLabels.upcomingMigration.inlineLabel"
      })
    })
  });
});
export const renderWithCondition = ConditionalLabel(condition, render);